<template>
    <div class="border-gray-800 border-b bg-gray-900 z-10 flex items-center px-6">
        <!-- LOGO -->
        <a class="pt-1 flex items-center space-x-2 cursor-pointer" href="/platform">
            <LogoIcon class=" h-4"></LogoIcon>
            <div class="font-black text-gray-100 ">
                Campflare
            </div>
            <div class="border text-gray-100  border-yellow-200 rounded-full px-2 text-xs font-reugular bg-yellow-900">
                Beta
            </div>
        </a>

        <a :class="`px-6 text-gray-200 pt-0.5 ml-20 cursor-pointer hover:opacity-70 ${pathName === '/platform' ? 'text-emerald-200' : 'text-gray-200'}`" href="/platform" >
            Home
        </a>

        <a :class="`px-6 text-gray-200 pt-0.5 cursor-pointer hover:opacity-70 ${pathName === '/platform/reference' ? 'text-emerald-200' : 'text-gray-200'}`" href="/platform/reference" >
            API Reference
        </a>
        <a :class="`px-6 text-gray-200 pt-0.5 cursor-pointer hover:opacity-70`" href="mailto:hello@campflare.com" target="_blank">
            Feedback
        </a>
        <a :class="`px-6 text-gray-200 pt-0.5 cursor-pointer hover:opacity-70`" href="mailto:support@campflare.com" target="_blank">
            Developer Support
        </a>

        <!-- <a :class="`px-6 text-gray-200 pt-0.5 cursor-pointer hover:opacity-70 ${pathName === '/platform/examples' ? 'text-emerald-200' : 'text-gray-200'}`" href="/platform/examples" >
            Examples
        </a>

        <a :class="`px-6 text-gray-200 pt-0.5 cursor-pointer hover:opacity-70 ${pathName === '/platform/licence' ? 'text-emerald-200' : 'text-gray-200'}`" href="/platform/licence" >
            Licence
        </a> -->

        <a class="ml-auto text-emerald-400 cursor-pointer hover:opacity-70" href="/platform/login" v-if="!loggedIn">
            Sign up
        </a>
        <a class="ml-auto text-emerald-400 cursor-pointer hover:opacity-70" href="/platform/account"  v-else>
            Account
        </a>

        


    </div>
    
</template>

<script>
// import HomePage from './HomePage.vue'
import LogoIcon from './LogoIcon.vue'

const pathName = window.location.pathname

export default {
    components: {
        LogoIcon,
        // HomePage
    },
    props: ["loggedIn"],
    data: () => {
        return {
            pathName
        }
    }
}
</script>
